import {Routes} from '@angular/router';
import {adminAuthGuard} from '@core/guards/admin-auth.guard';
import {userAuthGuard} from '@core/guards/user-auth.guard';

export const adminRoutes: Routes = [
  {path: 'admin', redirectTo: 'admin/dashboard', pathMatch: 'full'},

  {
    path: 'admin',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/admin/auth/admin-login-page/admin-login-page.component').then(
            (m) => m.AdminLoginPage,
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./features/admin/layout/admin-layout/admin-layout.component').then(
            (m) => m.AdminLayout,
          ),
        canActivate: [adminAuthGuard],
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            loadComponent: () =>
              import('./features/admin/admin-dashboard/admin-dashboard').then(
                (m) => m.AdminDashboard,
              ),
          },
          {
            path: 'products',
            loadComponent: () =>
              import('./features/admin/products/pages/products-page').then(
                (m) => m.ProductsPage,
              ),
          },
          {
            path: 'categories',
            loadComponent: () =>
              import('./features/admin/categories/pages/categories-page').then(
                (m) => m.CategoriesPage,
              ),
          },
          {
            path: 'orders',
            loadComponent: () =>
              import('./features/admin/orders/pages/orders').then((m) => m.Orders),
            children: [
              {
                path: ':id',
                loadComponent: () =>
                  import(
                    './features/admin/orders/components/table-cell-view-or-update/table-cell-view-or-update-order'
                  ).then((m) => m.TableCellViewOrUpdateOrder),
              },
            ],
          },
          {
            path: 'referrals',
            loadComponent: () =>
              import('./features/admin/referrals/pages/referrals-page').then(
                (m) => m.ReferralsPage,
              ),
          },
          {
            path: 'reports',
            loadComponent: () =>
              import('./features/admin/reports/pages/reports-page').then(
                (m) => m.ReportsPage,
              ),
          },
          {
            path: 'settings',
            loadComponent: () =>
              import('./features/admin/settings/settings').then((m) => m.Settings),
          },
        ],
      },
    ],
  },
];

export const userRoutes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {
    path: '',
    loadComponent: () =>
      import('./features/user/layout/layout').then((m) => m.Layout),
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./features/user/home/home-page').then((m) => m.HomePage),
      },
      {
        path: 'cart',
        loadComponent: () =>
          import('./features/user/cart/cart-page').then((m) => m.CartPage),
      },
      {
        path: 'shop',
        loadComponent: () =>
          import('./features/user/shop/shop-page').then((m) => m.ShopPage),
      },
      {
        path: 'checkout',
        loadComponent: () =>
          import('./features/user/checkout/checkout-page').then(
            (m) => m.CheckoutPage,
          ),
      },
      {
        path: 'order-success/:orderId',
        loadComponent: () =>
          import('./features/user/orders/order-success/order-success-page').then(
            (m) => m.OrderSuccessPage,
          ),
      },
      {
        path: 'order-history',
        loadComponent: () =>
          import('./features/user/orders/order-history/order-history-page').then(
            (m) => m.OrderHistoryPage,
          ),
        canActivate: [userAuthGuard],
      },
      {
        path: 'order-details/:orderId',
        loadComponent: () =>
          import('./features/user/orders/order-details/order-details-page').then(
            (m) => m.OrderDetailsPage,
          ),
        canActivate: [userAuthGuard],
      },
    ],
  },
  {
    path: 'shop',
    loadComponent: () =>
      import('./features/user/shop/shop-page').then((m) => m.ShopPage),
  },
  // Customer login / OTP disabled — keep components; restore routes when re-enabling auth
  // {
  //   path: '',
  //   loadComponent: () =>
  //     import('./features/user/auth/auth-page/auth-page').then((m) => m.AuthPage),
  //   children: [
  //     {
  //       path: 'login',
  //       loadComponent: () =>
  //         import('./features/user/auth/login-page/login-page/login-page').then(
  //           (m) => m.LoginPage,
  //         ),
  //     },
  //     {
  //       path: 'verify-otp-input/:phone-number',
  //       loadComponent: () =>
  //         import('./features/user/auth/verify-otp-page/verify-otp-page').then(
  //           (m) => m.VerifyOtpPage,
  //         ),
  //     },
  //   ],
  // },
  {
    path: 'catalog',
    loadComponent: () =>
      import('./features/user/shop/catalog/catalog.component').then(
        (m) => m.CatalogSection,
      ),
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./features/user/contact-us/contact-us-page').then(
        (m) => m.ContactUsPage,
      ),
  },
  {
    path: 'test',
    loadComponent: () =>
      import('./features/_test-page/test-page').then((m) => m.TestPage),
  },
];

export const routes: Routes = [
  ...adminRoutes,
  ...userRoutes,
];
